export default {
    name: "IncomeTaxMixin",
    methods: {
        transactionsByTags(tag, query=null) {
            this.$router.push({name: '거래내역', query: {...query, tag__path__contains: tag}, params: {transition: 'push'}})
        },
    }
}
